const uuid = require('uuid');

// don't change this UUID or consistency with anonymizing UUIDs
// will be broken
const pad = uuid.parse('2001decc-f27a-44c1-beb9-a2c0890d7ac7');

function validateUUIDv4Strict(v) {
  const regex = /^[a-f0-9]{8}-[a-f0-9]{4}-4[a-f0-9]{3}-[89aAbB][a-f0-9]{3}-[a-f0-9]{12}$/i;
  return regex.test(v);
}

module.exports = {
  isUUID(v) {
    return validateUUIDv4Strict(v);
  },

  validateUUID(v) {
    if ((typeof v === 'string') && (v.trim().length === 0)) {
      return true;
    }
    return validateUUIDv4Strict(v);
  },

  validateOptionalUUID(v) {
    if (!v || ((typeof v === 'string') && (v.trim().length === 0))) {
      return true;
    }

    return validateUUIDv4Strict(v);
  },

  anonymizeUUID(sourceUuid) {
    if (!sourceUuid) {
      return null;
    }
    const uuidBytes = uuid.parse(sourceUuid);
    const modifiedUuidBytes = uuidBytes.map((b, i) => (b + pad[i]) % 256);
    const modifiedUuid = uuid.v4({ random: modifiedUuidBytes });
    return modifiedUuid;
  },

  uuidv4: uuid.v4,
};
